import React from 'react';
import { getSettingsViewThunk } from '../../store/settings/thunks';
import { connect, ConnectedProps } from 'react-redux';
import { SuspenseWrapper } from './SuspenseWrapper';
import useGoBackOrGoHome from './redirects/useGoBackOrGoHome';
import { useAuthContext } from '../contexts/AuthContext/AuthContext';
import { CookieConsentData } from '../consent/types';
import { useAppFeaturesContext } from '../contexts/AppFeaturesContext/AppFeaturesContext';
import { getCookieConsentData } from '../consent/getCookieConsentData';

const SettingsViewLazy = React.lazy(
  () => import('../SettingsView/SettingsViewContainer')
);

const SettingsRoute: React.FC<Props> = ({ getSettingsView }) => {
  const goBackOrGoHomeRef = React.useRef(useGoBackOrGoHome());
  const { user } = useAuthContext();
  const { languageCode } = useAppFeaturesContext();
  const [consentData, setConsentData] =
    React.useState<CookieConsentData | null>();
  const [waitTarget, setWaitTarget] = React.useState<Promise<unknown>>();

  React.useEffect(() => {
    const consentPromise = getCookieConsentData(
      languageCode,
      goBackOrGoHomeRef.current
    ).then(data => setConsentData(data));
    const viewPromise = getSettingsView(user);

    setWaitTarget(Promise.all([consentPromise, viewPromise]));
  }, [getSettingsView, languageCode, user]);

  return (
    <SuspenseWrapper promiseToWait={waitTarget}>
      {consentData && (
        <SettingsViewLazy
          consentUiActions={consentData.actions}
          consentUiOptions={consentData.uiElementOptions}
          consentInfo={consentData.info}
        />
      )}
    </SuspenseWrapper>
  );
};

const mapDispatchToProps = {
  getSettingsView: getSettingsViewThunk,
};

const connector = connect(null, mapDispatchToProps);

type Props = ConnectedProps<typeof connector>;

export default connector(SettingsRoute);
